/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  DocumentDownloadResponse,
  PdfSourceDocument,
} from "../models/index";
import {
  DocumentDownloadResponseFromJSON,
  DocumentDownloadResponseToJSON,
  PdfSourceDocumentFromJSON,
  PdfSourceDocumentToJSON,
} from "../models/index";

export interface DownloadPdfSource1Request {
  slug: string;
}

/**
 *
 */
export class FrontPluginApi extends runtime.BaseAPI {
  /**
   */
  async downloadPdfSource1Raw(
    requestParameters: DownloadPdfSource1Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DocumentDownloadResponse>> {
    if (requestParameters["slug"] == null) {
      throw new runtime.RequiredError(
        "slug",
        'Required parameter "slug" was null or undefined when calling downloadPdfSource1().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["slug"] != null) {
      queryParameters["slug"] = requestParameters["slug"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/front-plugin/pdf-sources/download`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DocumentDownloadResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadPdfSource1(
    requestParameters: DownloadPdfSource1Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DocumentDownloadResponse> {
    const response = await this.downloadPdfSource1Raw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getPdfSourceDocuments1Raw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<PdfSourceDocument>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/front-plugin/pdf-sources`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(PdfSourceDocumentFromJSON),
    );
  }

  /**
   */
  async getPdfSourceDocuments1(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<PdfSourceDocument>> {
    const response = await this.getPdfSourceDocuments1Raw(initOverrides);
    return await response.value();
  }
}
